import { NotificationType as AppType } from '@/features/notifications/notification-service-extension-shared/constants/app'
import { NotificationType as FirebaseType } from '@/features/notifications/notification-service-extension-shared/constants/firebase'

export const appToFirebaseType = (type: AppType): FirebaseType => {
    switch (type) {
        case AppType.AcceptedOrder:
            return FirebaseType.AcceptedOrder
        case AppType.AwaitingAcceptanceOrder:
            return FirebaseType.AwaitingAcceptanceOrder
        case AppType.PostponedOrder:
            return FirebaseType.PostponedOrder
    }
}
